import React from "react";
import PropTypes from "prop-types";
import { Button } from "components/common";
import Clickable from "./Clickable";

/**
 * Thanh hành động hàng loạt — chỉ hiện khi có dòng được chọn, dính đáy vùng
 * cuộn để không phải kéo lên đầu bảng mới bấm được.
 */
const BulkActionBar = ({ count, onApprove, onClear, busy = false, limit }) => {
  if (!count) return null;

  const overLimit = limit != null && count > limit;

  return (
    <div className="tw-sticky tw-bottom-0 tw-z-20 tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-px-4 tw-py-2.5 tw-rounded-geist-md tw-border tw-border-solid tw-border-geist-border tw-bg-geist-bg tw-shadow-geist-modal">
      <span className="tw-text-[13px] tw-font-semibold tw-text-geist-fg">
        {count} selected
      </span>

      {overLimit && (
        <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-[11px] tw-text-geist-error">
          <i className="bi bi-exclamation-triangle" /> Max {limit} per batch — deselect {count - limit}.
        </span>
      )}

      <div className="tw-flex tw-items-center tw-gap-2 tw-ml-auto">
        <Clickable
          onClick={onClear}
          disabled={busy}
          className="tw-text-[12px] tw-font-medium tw-text-geist-fg-3 hover:tw-text-geist-fg tw-px-2 tw-transition-colors"
        >
          Clear
        </Clickable>
        <Button variant="primary" size="sm" disabled={busy || overLimit} onClick={onApprove}>
          {busy ? "Approving..." : "Approve selected"}
        </Button>
      </div>
    </div>
  );
};

BulkActionBar.propTypes = {
  count: PropTypes.number,
  onApprove: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  limit: PropTypes.number,
};

export default BulkActionBar;
